import React, {useState} from "react";
import {GridCell, gridConstants, GridContainer} from "../../../../Components/Grid";
import {CheckBoxItem} from "../../../../Components/Inputs/CheckboxField";
import {HtmlDisplay} from "../../../../Components/Display";
import {Button, NumberField, SelectField} from "../../../../Components/Inputs";

interface OwnQueueItemProps {
    ownCatalogItemId: string;
    ownQueueItemId: string;
    details: string;
    handleDelete?: () => void;
    handleSelectedItemsChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    isPendingQueue: boolean;
    isSelected?: boolean;
    title: string;
    quantity?: number;
    maxQuantity?: number;
    handleQuantityChange?: (id: string, quantity: number | undefined) => void;
    [key: string]: unknown;
}

export const OwnQueueItem = ({
                                 ownCatalogItemId,
                                 ownQueueItemId,
                                 details,
                                 handleDelete,
                                 handleSelectedItemsChange,
                                 isPendingQueue,
                                 isSelected,
                                 title,
                                 quantity,
                                 maxQuantity,
                                 handleQuantityChange,
                             }: OwnQueueItemProps) => {

    const hasOrderLimitCap = maxQuantity !== undefined;
    const displayQuantity = quantity ?? 1;
    const optionCount = Math.max(maxQuantity ?? displayQuantity, displayQuantity, 1);
    const quantityOptions = Array.from({length: optionCount}, (_, index) => ({
        value: String(index + 1),
        text: String(index + 1),
    }));

    const [quantityError, setQuantityError] = useState("");

    const onQuantityChange = (event: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
        const raw = event.target.value;
        if (raw === "") {
            setQuantityError("");
            handleQuantityChange?.(ownQueueItemId, undefined);
            return;
        }
        const numeric = Number(raw);
        if (Number.isFinite(numeric) && numeric < 1) {
            setQuantityError("Please select a valid value. The nearest valid value is 1.");
            event.target.value = "1";
            handleQuantityChange?.(ownQueueItemId, 1);
            return;
        }
        setQuantityError("");
        handleQuantityChange?.(ownQueueItemId, numeric);
    };

    return <>
        <GridContainer className={`catalog__item`} hasMarginX>

            <GridCell small_columns={gridConstants.column.TWO} medium_columns={gridConstants.column.ONE}>
                {
                    isPendingQueue &&
                    <CheckBoxItem checked={isSelected} hideLabel label={`Select ${title}`} name={`cb${ownQueueItemId}`}
                                  onChange={handleSelectedItemsChange} value={ownQueueItemId}/>
                }
            </GridCell>
            <GridCell small_columns={gridConstants.column.TEN} medium_columns={gridConstants.column.ELEVEN}>
                <h3 className={`margin--bottomNone`}>{title}</h3>
                <HtmlDisplay html={details}/>
                {
                    isPendingQueue
                        ? (hasOrderLimitCap
                            ? <SelectField
                                includeDefaultOption={false}
                                label={`Quantity`}
                                name={`quantity-${ownQueueItemId}`}
                                onChange={onQuantityChange}
                                options={quantityOptions}
                                value={String(displayQuantity)}
                                medium_columns={gridConstants.column.TWO}
                            />
                            : <NumberField
                                isWholeNumberOnly
                                error={quantityError}
                                label={`Quantity`}
                                name={`quantity-${ownQueueItemId}`}
                                onChange={onQuantityChange}
                                placeholder={`1`}
                                value={quantity}
                                medium_columns={gridConstants.column.TWO}
                            />)
                        : <p className={`margin--bottomNone`}><b>{displayQuantity}</b> (Quantity)</p>
                }
                {
                    handleDelete &&
                    <Button isCollapsed label={`Cancel Request`} name={`btnDelete${ownCatalogItemId}`}
                            onClick={handleDelete}/>
                }
            </GridCell>
        </GridContainer>
    </>;
};
